import { makeApiProxyRequest } from '@frontastic/bridge/js/makeApiProxyRequest';

interface RequestOptions {
  method?: 'GET' | 'POST';
  headers?: Record<string, string>;
  body?: string;
}

const fetch = (url: string, options?: RequestOptions): Promise<Response> => {
  return makeApiProxyRequest(
    {
      path: url,
    },
    options?.body,
    options?.method,
    options?.headers,
  );
};

export default fetch;
